export default __webpack_public_path__ + "static/media/twoPeopleBundle.b4973a61.png";